(() => {
function init(root) {
 if (root.dataset.ready) return;
 const compact = !!root.closest('[data-regular-product]');
 const images = [...root.querySelectorAll('[data-gallery-image]')];
 if (!images.length) return;
 root.dataset.ready = 'true';
 const main = root.querySelector('.vital-gallery-main img');
 const mainButton = root.querySelector('[data-gallery-open]');
 const pairs = root.querySelector('[data-gallery-pairs]');
 const small = root.querySelector('[data-gallery-small]');
 const dialog = root.querySelector('dialog');
 const large = root.querySelector('[data-gallery-large]');
 const video = root.querySelector('[data-gallery-video]');
 const label = root.querySelector('[data-gallery-main-label]');
 const tray = root.querySelector('[data-gallery-dialog-thumbs]');
 const details = root.closest('.product-layout').querySelector('[data-product-details]');
 let selected = Math.max(0, images.findIndex(b => b.getAttribute('aria-pressed') === 'true'));
 const clones = images.map((button, index) => {
  const clone = button.cloneNode(true);
  clone.removeAttribute('data-gallery-image');
  clone.addEventListener('click', () => select(index));
  tray.append(clone); return clone;
 });
 function select(index) {
  selected = (index + images.length) % images.length;
  const button = images[selected];
  const alt = button.querySelector('img').alt;
  const isVideo = button.dataset.kind === 'video';
  video.pause();
  video.hidden = !isVideo;
  large.hidden = isVideo;
  main.removeAttribute('srcset'); main.src = isVideo ? button.querySelector('img').src : button.dataset.full; main.alt = alt;
  label.textContent = isVideo ? label.dataset.videoLabel : label.dataset.imageLabel;
  if (isVideo) { if (video.getAttribute('src') !== button.dataset.full) video.src = button.dataset.full; video.poster = button.querySelector('img').src; }
  else { large.src = button.dataset.full; large.alt = alt; }
  images.forEach((b,i) => b.setAttribute('aria-pressed', String(i === selected)));
  clones.forEach((b,i) => b.setAttribute('aria-pressed', String(i === selected)));
  root.querySelector('[data-gallery-count]').textContent = (selected+1) + ' / ' + images.length;
 }
 function open(index) { select(index); dialog.showModal(); if (!video.hidden) video.play().catch(() => {}); }
 images.forEach((button,i) => button.addEventListener('click', () => compact ? select(i) : open(i)));
 mainButton.addEventListener('click', () => open(selected));
 root.querySelector('[data-gallery-close]').addEventListener('click', () => dialog.close());
 root.querySelector('[data-gallery-prev]').addEventListener('click', () => select(selected-1));
 root.querySelector('[data-gallery-next]').addEventListener('click', () => select(selected+1));
 dialog.addEventListener('keydown', e => {
  if (e.key === 'ArrowLeft') { e.preventDefault(); select(selected-1); }
  if (e.key === 'ArrowRight') { e.preventDefault(); select(selected+1); }
 });
 let oldOverflow = '';
 dialog.addEventListener('close', () => { video.pause(); document.documentElement.style.overflow = oldOverflow; });
 mainButton.addEventListener('click', lock);
 if (!compact) images.forEach(b => b.addEventListener('click', lock));
 function lock() { oldOverflow = document.documentElement.style.overflow; document.documentElement.style.overflow = 'hidden'; }
 let pending = 0;
 function layout() {
  pending = 0;
  if(compact){images.forEach(button=>{small.append(button);button.hidden=false;});return;}
  const width = root.clientWidth;
  const rowHeight = (width - 12) / 2 + 12;
  let count;
  if (window.matchMedia('(max-width:760px)').matches) { count = Math.min(4,images.length-1); }
  else {
   // Reserve space for every remaining compact thumbnail before adding a large row.
   const room = details.getBoundingClientRect().height - mainButton.getBoundingClientRect().height;
   const columns = Math.max(1,Math.floor((width + 8) / 72));
   count = 0;
   for (let n=2; n<=images.length-1; n+=2) {
    const remaining = images.length-1-n;
    const reserve = remaining ? Math.ceil(remaining/columns)*98+12 : 0;
    if (Math.ceil(n/2)*rowHeight+reserve <= room) count=n; else break;
   }
  }
  // Keep the first image in the main stage; additional pictures fill two columns.
  images.slice(1).forEach((button,i) => {
   const parent = i < count ? pairs : small;
   parent.append(button);
  });
  if (images[0].parentElement !== small) small.prepend(images[0]);
  images[0].hidden = true;
 }
 function schedule() { if (!pending) pending = requestAnimationFrame(layout); }
 if ('ResizeObserver' in window) { const observer=new ResizeObserver(schedule); observer.observe(details); observer.observe(mainButton); }
 window.addEventListener('resize', schedule, {passive:true});
 select(selected); layout();
}
function initAll() { document.querySelectorAll('[data-vital-gallery]').forEach(init); }
initAll(); document.addEventListener('shopify:section:load', initAll);
})();

